import React from "react";
import "./brokerInventoryManagement.css";
import broker_inventory1 from "assets/brokerInventory/broker_inventory1.png";
import broker_inventory2 from "assets/brokerInventory/broker_inventory2.png";
import broker_inventory3 from "assets/brokerInventory/broker_inventory3.png";
import { Link } from "react-scroll";
import { useNavigate } from "react-router-dom";

const BrokerInventoryManagement = () => {
  const navigate = useNavigate();

  const handleGetDemo = (e) => {
    e.preventDefault();
    navigate("../request-a-demo");
  };

  return (
    <div className="broker-inventory-container">
      <div className="broker-inventory-top-heading">
        <h1>Stay on top of your inventory</h1>
        <p>
          Gain complete control and visibility over your inventory through
          tracking of new projects, resale properties, rentals and other assets.
        </p>
        <button onClick={handleGetDemo} className="marketingAutomation-btn">
          GET A DEMO
        </button>
      </div>
      <div className="row">
        <div className="col-12 broker-inventory-col">
          <div className="col-3">
            <div className="right-side-heading">
              <h2>Broker Inventory Management</h2>
              <Link
                to="inventory-tracking"
                smooth={true}
                duration={500}
                offset={-90}
              >
                Real-time inventory tracking
              </Link>
              <Link
                to="stakeholder-management"
                smooth={true}
                duration={500}
                offset={-90}
              >
                Easy stakeholder management
              </Link>
              <Link
                to="advance-search-property"
                smooth={true}
                duration={500}
                offset={-90}
              >
                Advance Search for Property Match
              </Link>
            </div>
          </div>
          <div className="col-9">
            <div className="broker-inventory-section" id="inventory-tracking">
              <div className="broker-inventory-heading">
                <h2>Real-time inventory tracking</h2>
                <p>
                  Keep track of inventory and assets across multiple projects,
                  their stages and locations with easy inventory search based on
                  custom parameters
                </p>
                <p>
                  When it comes to real estate, I believe you’re referring to a
                  property such as an apartment, condo unit, bungalow house, or
                  villa. If you own a real estate business, these properties are
                  usually sold or rented out.
                </p>
              </div>
              <div className="broker-inventory-img">
                <img src={broker_inventory1} alt="" />
              </div>
            </div>
            <div
              className="broker-inventory-section"
              id="stakeholder-management"
            >
              <div className="broker-inventory-heading">
                <h2>Easy stakeholder management</h2>
                <p>
                  A stakeholder is anyone who impacts on, or is impacted by, the
                  property development process. This means it's not only
                  'professionals' who are involved in buying, developing and
                  managing property.
                </p>
                <p>
                  Manage all your developers, buyers, sellers, owners and
                  tenants through a single dashboard.
                </p>
              </div>
              <div className="broker-inventory-img">
                <img src={broker_inventory2} alt="" />
              </div>
            </div>
            <div
              className="broker-inventory-section"
              id="advance-search-property"
            >
              <div className="broker-inventory-heading">
                <h2>Advance Search for Property Match</h2>
                <p>
                  A Real Estate website contains listings for residential or
                  commercial properties, on sale, lease or rent. For a city
                  there maybe hundreds of listings. For a country wide real
                  estate website, this number will be substantially larger. Each
                  property has certain attributes, like location, area, price,
                  description, etc. Considering that such parameters would be
                  considered when searching for a listing on a country wide real
                  estate website, the complexity of the search increases.
                </p>
                <p>
                  Quickly match new leads to inventory and vice-versa on-the-go.
                </p>
              </div>
              <div className="broker-inventory-img">
                <img src={broker_inventory3} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrokerInventoryManagement;
